import styles from "./profile.module.css";
import UserProfile from "./UserProfile";
import { FiEdit } from "react-icons/fi";
import { FaPlusCircle } from "react-icons/fa";
import { useState, useEffect } from "react";
import { AiOutlineLeft, AiOutlineUser } from "react-icons/ai";
import { FaRegUserCircle } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import Modal from "./modal/Modal";
import sendRequest from "hooks/useAxios";
import Message from "components/messages/Message";
import Helmet from "react-helmet";
import toast from "react-hot-toast";

import { NavLink, Link } from "react-router-dom";
function Profile() {
  const [updater, setUpdater] = useState(true);
  const [messages, setMessages] = useState([]);
  const [SelectedUserInformation, setSelectedUserInformation] = useState({
    num: "",
    email: "",
    postalCode: "",
    fName: "",
    lName: "",
    codeMeli: "",
    address: "",
    profilepic: null,
    id: "",
  });
  useEffect(() => {
    // to do : get user id

    sendRequest("getuser").then(({ data }) => {
      setSelectedUserInformation({
        num: data.userInfo.mobile,
        fName: data.userInfo.fname,
        lName: data.userInfo.lname,
        codeMeli: data.userInfo.codemeli,
        email: data.userInfo.email,
        postalCode: data.userInfo.postcode,
        address: data.userInfo.address,
        profilepic: data.userInfo.url,
        id: data.userInfo.id,
      });
    });
  }, [updater]);
  useEffect(() => {
    sendRequest("Find_notifications").then(({ data }) => {
      setMessages(data);
    });
  }, []);
  function updateUser(values) {
    sendRequest("updateuser", {
      updateValue: `fname,${values.fName}@@lname,${values.lName}@@codemeli,${values.codeMeli}@@email,${values.email}@@mobile,${values.num}@@postcode,${values.postalCode}@@address,${values.address}`,
      file: values.profilepic,
    }).then(({ data }) => {
      if (data.status == 1) {
        document
          .querySelector(".edit-customer-profile-modal .close-btn")
          .click();
        toast.success("با موفقیت ویرایش شد.");
        setUpdater(!updater);
      } else {
        toast.error("مشکلی در ویرایش پیش آمده است.");
      }
    });
  }

  return (
    <div className="w-100">
      <Helmet>
        <title>پروفایل</title>
      </Helmet>
      {console.log("ss", SelectedUserInformation.profilepic)}
      <div className={styles.mobilePic}>
        <div className="edit-user-item d-flex justify-content-center">
          <div className="profile-pic position-relative">
            <img
              src={
                "http://oilb.tatdemo.ir/" + SelectedUserInformation.profilepic
              }
              style={{ width: "100px", height: "100px", borderRadius: "50%" }}
            />
          </div>
        </div>
      </div>

      <div dir="ltr" className={styles.tableContainer}>
        <table className={`table mb-0 text-center ${styles.sotun}`}>
          <tbody className={styles.radif}>
            <tr>
              <td>
                <p>
                  {SelectedUserInformation.fName +
                    " " +
                    SelectedUserInformation.lName}
                </p>
              </td>
              <th width="50%" height="50px" scope="row">
                <p className="mt-2"> نام و نام خانوادگی </p>
              </th>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="mt-2">{SelectedUserInformation.codeMeli} </p>{" "}
              </td>
              <th className="rowHead" height="50px" scope="row">
                <p className="mt-2"> کد ملی</p>
              </th>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="mt-2">{SelectedUserInformation.num} </p>{" "}
              </td>
              <th className="rowHead" height="50px" scope="row">
                <p className="mt-2"> شماره تماس</p>
              </th>
            </tr>
            <tr>
              <td>
                <p className="mt-2">{SelectedUserInformation.email} </p>
              </td>
              <th className="rowHead" height="50px" scope="row">
                <p className="mt-2"> ایمیل </p>
              </th>
            </tr>
            <tr>
              <td>
                <p className="mt-2">{SelectedUserInformation.address}</p>{" "}
              </td>
              <th className="rowHead" height="50px" scope="row">
                <p className="mt-2">آدرس </p>
              </th>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="mt-2">
                  {SelectedUserInformation.postalCode}{" "}
                </p>{" "}
              </td>
              <th className="rowHead" height="50px" scope="row">
                <p className="mt-2">کد پستی</p>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.editInfo}>
        <div className=" text-end mx-3 mt-2">
          <p data-bs-toggle="modal" data-bs-target={`#exampleModal`}>
            ویرایش اطلاعات
          </p>
        </div>
      </div>
      <Modal
        SelectedUserInformation={SelectedUserInformation}
        updateUser={updateUser}
      />
      <div className={styles.widthDisplay}>
        <div
          className={`d-flex justify-content-around mt-5 ${styles.containerMainj}`}
        >
          <UserProfile
            label="نام و نام خانوادگی"
            fName={SelectedUserInformation.fName}
            lName={SelectedUserInformation.lName}
            emailLabel="کد ملی"
            codeMeli={SelectedUserInformation.codeMeli}
            postal="آدرس"
            id={2}
            address={SelectedUserInformation.address}
          />
          <div className=" d-flex flex-column justify-content-around align-item-center">
            <div className="edit-user-item d-flex justify-content-center">
              <label htmlFor="profile-pic">
                <div className="profile-pic position-relative">
                  {SelectedUserInformation.profilepic != null ? (
                    <img
                      src={
                        "http://oilb.tatdemo.ir/" +
                        SelectedUserInformation.profilepic
                      }
                      alt=""
                      style={{
                        width: "80px",
                        borderRadius: "50%",
                        height: "80px",
                        overflow: "hidden",
                      }}
                    />
                  ) : (
                    <AiOutlineUser style={{ width: "80px", height: "80px" }} />
                  )}

                  <label
                    htmlFor="ProfilePic"
                    className="position-absolute text-dark"
                    style={{ right: "3px", top: "-10px" }}
                  ></label>
                </div>
              </label>
            </div>

            <div className="text-center">
              <button
                type="button"
                className={`mb-2  ${styles.modalBtn}`}
                data-bs-toggle="modal"
                data-bs-target={`#exampleModal`}
              >
                <FiEdit />
              </button>
              <p>ویرایش اطلاعات</p>
            </div>
            <Modal
              SelectedUserInformation={SelectedUserInformation}
              updateUser={updateUser}
            />
          </div>
          <UserProfile
            label="شماره تماس"
            num={SelectedUserInformation.num}
            emailLabel="ایمیل"
            email={SelectedUserInformation.email}
            postal="کد پستی"
            postalCode={SelectedUserInformation.postalCode}
            id={1}
          />
        </div>
      </div>

      <div className="w-75 m-auto mt-4">
        <h4 dir="rtl">سفارش های من</h4>
      </div>
      <section
        className={`d-flex justify-content-around m-auto mt-4 ${styles.orders}`}
      >
        <Link
          to="/customer-panel/orders/?type=0"
          style={{ textDecoration: "none" }}
        >
          <div
            className={`d-flex flex-column justify-content-around text-center align-item-center ${styles.cancledBox}`}
          >
            <img
              alt="cancled"
              src="/images/stopwatch.svg"
              className={styles.imgCancled}
            />
            <p style={{ color: "black", textDecoration: "none !important" }}>
              در انتظار پرداخت
            </p>
          </div>
        </Link>
        <Link
          style={{ textDecoration: "none", color: "black" }}
          to="/customer-panel/orders/?type=1"
        >
          <div
            className={`d-flex flex-column justify-content-around text-center align-item-center ${styles.cancledBox}`}
          >
            <img
              alt="cancled"
              src="/images/3281345.svg"
              className={styles.imgCancled}
            />
            <p>در حال پردازش</p>
          </div>{" "}
        </Link>{" "}
        <Link
          style={{ textDecoration: "none", color: "black" }}
          to="/customer-panel/orders/?type=2"
        >
          <div
            className={`d-flex flex-column justify-content-around text-center align-item-center ${styles.cancledBox}`}
          >
            <img
              alt="cancled"
              src="/images/1337181.svg"
              className={styles.imgCancled}
            />
            <p>ارسال شده</p>
          </div>{" "}
        </Link>{" "}
        <Link
          style={{ textDecoration: "none", color: "black" }}
          to="/customer-panel/orders/?type=3"
        >
          <div
            className={`d-flex flex-column justify-content-around text-center align-item-center ${styles.cancledBox}`}
          >
            <img
              alt="cancled"
              src="/images/cancel.svg"
              className={styles.imgCancled}
            />
            <p>لغو شده</p>
          </div>
        </Link>
      </section>
      <div className="w-75 m-auto mt-4">
        <h4 dir="rtl">جدیدترین پیام های من</h4>
        <div>
          {[...messages]
            .reverse()
            .slice(0, 3)
            .map((value) => {
              return (
                <Message
                  type={+value.table_soucre_code}
                  time={parseInt(value.mtm)}
                  description={value.txt}
                ></Message>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default Profile;
